import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { RouteSegment } from 'app/enums/route-segments.enum';
import { LoggedInGuard } from 'app/guards/logged-in.guard';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent {
    public text$!: Observable<string>;
    private backRouteSegment!: string;

    constructor(
        private readonly loggedInGuard: LoggedInGuard,
        private readonly translocoService: TranslocoService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.loggedInGuard
            .canActivate()
            .pipe(
                tap((canActivate) => {
                    this.backRouteSegment = canActivate ? RouteSegment.Projects : RouteSegment.Root;
                })
            )
            .subscribe((data) => {
                data
                    ? (this.text$ = this.translocoService.selectTranslate('buttons.mainPage'))
                    : (this.text$ = this.translocoService.selectTranslate('buttons.backToLogin'));
            });
    }

    public onBackClick(): void {
        this.router.navigate([this.backRouteSegment]);
    }
}
